export const CATEGORY_IMAGES = {
  Food: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  Drinks: "https://images.unsplash.com/photo-1613158556069-e7d8eae76214?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  "Take Away": "https://images.unsplash.com/photo-1761315631835-0c42140646b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  Misc: "https://images.pexels.com/photos/19674142/pexels-photo-19674142.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export function categoryFallbackImage(category) {
  return CATEGORY_IMAGES[category] || CATEGORY_IMAGES.Misc;
}
